import config from '../config';
import Logger from '../logger';
import event from '../mixins/event';

class ThemeSplitTextBanner {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeSplitTextBanner';

		this.dom = dom;
		this.readMoreContentActiveClass = 'theme-split-text-banner__read-more--active';
		this.readMoreButtonDoms = this.dom.querySelectorAll('[data-theme-split-text-banner-read-more]');
		this.readMoreContentDoms = this.dom.querySelectorAll('[data-theme-split-text-banner-read-more-content]');
	}

	/**
	 * init - Initialize the component
	 **/
	init() {
		Logger.info(`${this.NAME} > init`);
		if (!this.readMoreButtonDoms.length) return;
		this.readMoreButtonDoms.forEach(readMoreButtonDom => {
			readMoreButtonDom.addEventListener('click', this.handleReadMore.bind(this));
		});
	}

	/**
	 * handleReadMore
	 */
	handleReadMore(event) {
		Logger.info(`${this.NAME} > handleReadMore`);
		const readMoreButtonDom = event.currentTarget;

		//Get the parent of the read more button
		const readMoreContentDom = readMoreButtonDom.parentElement.querySelector('[data-theme-split-text-banner-read-more-content]');
		readMoreContentDom.classList.toggle(this.readMoreContentActiveClass);

		// Change the text of the read more button depending on the current state
		if (readMoreContentDom.classList.contains(this.readMoreContentActiveClass)) {
			readMoreButtonDom.textContent = '- Read less';
		} else {
			readMoreButtonDom.textContent = '+ Read more';
		}
	}

}

Object.assign(ThemeSplitTextBanner.prototype, event);

export default ThemeSplitTextBanner;
